import type { QueryFunctionContext } from '@tanstack/react-query';
import qs from 'qs';
import bookingInstance from '@/lib/axios/booking-instance';
import { handleRequest } from '@/lib/api/factories/base-api-factory';
import type { IBaseResponse } from '@/types/base-response';
import type { IGiftCardValue } from './gift-card-value.types';
import {
  toGiftCardValuePayload,
  type GiftCardValueValues,
} from './gift-card-value.utils';

/**
 * `/gift-card-setting` requires `companyId` on the list; the company-scope
 * interceptor attaches it, as it does for every read.
 */
const getGiftCardValueList = ({ queryKey }: QueryFunctionContext) =>
  handleRequest<IBaseResponse<IGiftCardValue[]>>(
    bookingInstance.get('/gift-card-setting', {
      params: queryKey[1],
      paramsSerializer: (value: Record<string, unknown>) =>
        qs.stringify(value, { arrayFormat: 'repeat' }),
    })
  );

const getGiftCardValueById = ({ queryKey }: QueryFunctionContext) =>
  handleRequest<IBaseResponse<IGiftCardValue>>(
    bookingInstance.get(`/gift-card-setting/${queryKey[1]}`)
  );

const createGiftCardValue = (values: GiftCardValueValues) =>
  handleRequest(
    bookingInstance.post(
      '/gift-card-setting',
      toGiftCardValuePayload(values, { create: true })
    )
  );

const editGiftCardValue = ({
  id,
  data,
}: {
  id: string;
  data: GiftCardValueValues;
}) =>
  handleRequest(
    bookingInstance.put(
      `/gift-card-setting/${id}`,
      toGiftCardValuePayload(data, { create: false })
    )
  );

const GiftCardValueService = {
  getGiftCardValueList,
  getGiftCardValueById,
  createGiftCardValue,
  editGiftCardValue,
};

export { GiftCardValueService };
